import React from 'react'
import styles from './styles.module.css'

const PageHeader = ({ children }) => (
  <header className={styles.header}>{children}</header>
)

export default PageHeader
